var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHiddenIcon = function SvgHiddenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hidden-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.143 12.857a.58.58 0 0 0 .825 0l2.279-2.279.038-.038 1.388-1.388a2.528 2.528 0 0 0 3.479-3.478l1.4-1.4.013-.013 2.293-2.292a.583.583 0 1 0-.826-.825L10.055 3.12A6.25 6.25 0 0 0 7 2.334c-3.113 0-5.01 2.17-5.863 3.465a2.18 2.18 0 0 0 0 2.403c.38.576.982 1.348 1.82 2.016l-1.814 1.814a.583.583 0 0 0 0 .825m2.645-3.47 1.06-1.06a2.528 2.528 0 0 1 3.479-3.479l.86-.86a5.1 5.1 0 0 0-2.186-.487c-2.568 0-4.165 1.843-4.89 2.94-.22.335-.22.785 0 1.12.347.525.904 1.235 1.677 1.826m1.882 2.14c.43.092.878.14 1.33.14 3.113 0 5.01-2.17 5.863-3.465a2.18 2.18 0 0 0 0-2.403 9 9 0 0 0-.809-1.055.584.584 0 0 0-.872.775c.255.287.493.597.707.922.221.334.221.784 0 1.12C11.165 8.657 9.567 10.5 7 10.5a5 5 0 0 1-1.085-.114.585.585 0 0 0-.245 1.14",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hidden-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgHiddenIcon;